
const VehicleSearch = () => import(/* webpackChunkName: "vehicle" */ "@pages/Vehicle/VehicleSearch.vue")
const VehicleDetail = () => import(/* webpackChunkName: "vehicle" */ "@pages/Vehicle/VehicleDetail.vue")
const VehicleDetailInformation = () => import(/* webpackChunkName: "vehicle" */ "@pages/Vehicle/Detail/VehicleDetailInformation.vue")
const VehicleDetailEdit = () => import(/* webpackChunkName: "vehicle" */ "@pages/Vehicle/Detail/VehicleDetailEdit.vue")
const VehicleDetailUsages = () => import(/* webpackChunkName: "vehicle" */ "@pages/Vehicle/Detail/VehicleDetailUsages.vue")
const VehicleDetailReadings = () => import(/* webpackChunkName: "vehicle" */ "@pages/Vehicle/Detail/VehicleDetailReadings.vue")
const VehicleDetailAssignments = () => import(/* webpackChunkName: "vehicle" */ "@pages/Vehicle/Detail/VehicleDetailAssignments.vue")
const VehicleDetailTelematics = () => import(/* webpackChunkName: "vehicle" */ "@pages/Vehicle/Detail/VehicleDetailTelematics.vue")
const VehicleDetailLicences = () => import(/* webpackChunkName: "vehicle" */ "@pages/Vehicle/Detail/VehicleDetailLicences.vue")

export default [
  {
    name: 'vehicles.search',
    path: 'vehicles',
    component: VehicleSearch,
    meta: {
      auth: true,
    },
  },
  {
    path: 'vehicles/:id',
    component: VehicleDetail,
    children: [
      {
        name: 'vehicle.detail',
        path: '',
        component: VehicleDetailInformation,
      },
      {
        name: 'vehicle.edit',
        path: 'edit',
        component: VehicleDetailEdit,
      },
      {
        name: 'vehicle.usages',
        path: 'usages',
        component: VehicleDetailUsages,
      },
      {
        name: 'vehicle.readings',
        path: 'readings',
        component: VehicleDetailReadings,
      },
      {
        name: 'vehicle.assignments',
        path: 'assignments',
        component: VehicleDetailAssignments,
      },
      {
        name: 'vehicle.telematics',
        path: 'telematics',
        component: VehicleDetailTelematics,
      },
      {
        name: 'vehicle.licences',
        path: 'licences',
        component: VehicleDetailLicences,
      },
    ]
  },
]
